import { createFileRoute } from '@tanstack/react-router'
import { PrivacyPolicyPage } from '@/components/infoPages/PrivacyPolicyPage'
import { withPublicPageSeo } from '@/modules/seo'

const PrivacyPolicyPageWithSeo = withPublicPageSeo('privacyPolicy', PrivacyPolicyPage)

export const Route = createFileRoute('/privacy-policy')({
  component: PrivacyPolicyPageWithSeo,
})

